export default "__VITE_PUBLIC_ASSET__3a7c5b68__"